/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/examples/Profile.jsx";
import Register from "views/examples/Register.jsx";
import Login from "views/examples/Login.jsx";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import Historique from "views/examples/Historique";
import MyDemands from "views/examples/MyDemands";
import AddDemande from "views/examples/AddDemande";
import Holidays from "views/examples/Holidays";
import PlanDetail from "views/admin/PlanDetail";
var routes2 = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <Index />,
    layout: "/admin",
  },
  
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
  },
  
  {
    path: "/myDemands",
    name: "My Demands List",
    icon: "ni ni-bullet-list-67 text-red",
    component: <MyDemands />,
    layout: "/admin",
  },
  {
    path: "/addDemande",
    name: "add new demand",
    icon: "ni ni-fat-add text-red",  
    component: <AddDemande />,
    layout: "/admin",
  },
  {
    path: "/History",
    name: "History",
    icon: "ni ni-time-alarm text-orange",
    component: <Historique />,
    layout: "/admin",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
  },
  {
  path: "detail-plan/:planId",
  name: "Detail Plan",
  icon: "ni ni-fat-add text-primary",
  component: <PlanDetail />,
  layout: "/tenant",
  sidebar: false

}
];
export default routes2;
